export default __webpack_public_path__ + "fonts/inter-latin-800-normal.0a74b4142326f19f9ac3.woff2";